module.exports = __webpack_public_path__ + "img/09 - Condominio_das_Americas_QuadraTenis.71da6f8e.jpg";